'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'

import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Button  from 'react-bootstrap/Button';

import FacetFilter from './FacetFilter';
import TimeRangeFilter from './TimeRangeFilter';
import HelpPopover from '@uw-it-sis/lib-react/lib/HelpPopover';

/**
 * Groups a collection of facet filters.
 *
 * For example if the facet is for course subject area the filters the facet would contain would be something like
 * ENGL, MATH, COM.
 */
const Facet = function(props) {

    const _facetReset = function(e) {
        props.handleResetFacet(e);
    };

    let facetModel = props.facetModel;

    /*
     * If the facet isn't actionable (aka only one filter is actionable) then don't render the facet.
     */
    if ( ! facetModel.isActionable() ) {
        return null;
    }

    /*
     * Only build the clear link if the allFiltersActive override is off (implying that at least one filter
     * could be cleared).
     */
    let clearSelections = null;
    if ( ! facetModel.isAllFiltersActive() ) {
        clearSelections =
            <Button variant="inline-link" id={facetModel.getId() + "__all"}
                    className="facet-clear-link"
                    aria-label={'Remove all filters for ' + facetModel.getLabel()}
                    onClick={_facetReset}>Clear</Button>;
    }

    let filterElement = null;
    let component = facetModel.getComponent();
    if (component === "slider") {
        // If the component is a time slider then create a TimeRangeFilter.
        filterElement = <TimeRangeFilter facetModel={facetModel} handleFilterChange={props.handleFilterChange} className="clearfix"/>;
    } else {
        // Otherwise, create a normal filter component (button or checkbox is handled internally within Filter)
        let filters = facetModel.getFilterModels().map(function (filterModel, i) {
            return <FacetFilter key={i} filterModel={filterModel} handleFilterChange={props.handleFilterChange} component={facetModel.getComponent()}/>;
        });

        if (component === "button") {
            filterElement = <ButtonToolbar>{filters}</ButtonToolbar>;
        } else {
            filterElement = filters;
        }
    }

    let facetHeadingHelp = null;
    if (facetModel.getHelpContent()) {
        facetHeadingHelp = <HelpPopover title={facetModel.getLabel() + " Help"} className="ms-1 align-middle">{facetModel.getHelpContent()}</HelpPopover>;
    }

    let facetHeading =
        <legend className="m-0 flex-grow-1 fw-bolder fs-6">
            <span className="align-middle">{facetModel.getLabel()}</span>
            {facetHeadingHelp}
        </legend>;

    return (
        <fieldset role="group" className={classnames("px-3", "pb-4", facetModel.getCssClasses())}>
            <div className="d-flex mb-2">
                {facetHeading}
                {clearSelections}
                <span className="sr-only">Select or Remove a filter for {facetModel.getLabel()} from the list</span>
            </div>
            {filterElement}
        </fieldset>
    );
};

Facet.propTypes = {
    /*
     * Supported component values: button, checkbox, slider
     */
    component: PropTypes.string,
    handleFilterChange: PropTypes.func.isRequired,
    handleResetFacet: PropTypes.func.isRequired,
    facetModel: PropTypes.object.isRequired
};

export default Facet;